let toggleVars = {
  hideSideNav: true,
  showLMSConfiguration: true,
  demoMode: false,
  hideAdminSideNav: true,
  showMobileApps: false,
}

export { toggleVars }
